import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    error: null,
    listInvoice: [],
    listInvoiceDetail: [],
    fileBase64: '',
    fileName: '',
    responseReprocess: [],
    responseEmail: null,
    currentFilterStatus: '',
    selectedInvoices: [],
    statusGenerateReportStatus: null,
    statusGenerateReportMessage: '',
    lastFilterParams: null,
  },
  getters: {},
  mutations: {

    setListInvoice (state, data) {
      state.listInvoice = data
      state.error = null
    },
    setListInvoiceDetail (state, data) {
      state.listInvoiceDetail = data
      state.error = null
    },
    setFileBase64 (state, data) {
      state.fileBase64 = data
      state.error = null
    },
    setNameFileBase64 (state, data) {
      state.fileName = data
      state.error = null
    },
    setResponseReprocess (state, data) {
      state.responseReprocess = data
      state.error = null
    },
    setResponseEmail (state, data) {
      state.responseEmail = data
      state.error = null
    },
    setCurrentFilterStatus (state, status) {
      state.currentFilterStatus = status
      state.error = null
    },
    setSelectedInvoices (state, invoices) {
      console.log(invoices);
      state.selectedInvoices = invoices
      state.error = null
    },
    setStatusGenerateReportStatus (state, status) {
      state.statusGenerateReportStatus = status
      state.error = null
    },
    setStatusGenerateReportMessage (state, message) {
      state.statusGenerateReportMessage = message
      state.error = null
    },
    setLastFilterParams (state, params) {
      state.lastFilterParams = params
      state.error = null
    },

  },
  actions: {
    getListInvoice ({ commit }, data) {
      let params = 'IdCompania=' + (data.IdCompania || JSON.parse(atob(localStorage.getItem('uid'))).idcompania)

      if (data.Consecutivo) {
        params += `&Consecutivo= ${data.Consecutivo}`
      }
      if (data.Status && data.Status !== '') {
        params += `&Estado= ${data.Status}`
      }
      if (data.Prefix) {
        params += `&Prefijo= ${data.Prefix}`
      }
      if (data.dates) {
        if(Array.isArray(data.dates)){
          params += `&FechaInicial= ${data.dates[0]}`
          params += `&FechaFinal= ${data.dates[1]}`
        }else{
          params += `&FechaInicial= ${data.dates}`
          params += `&FechaFinal= ${data.dates}`
        }

      }
      const endpoint = '/getInvoices?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setListInvoice', response.data.respuesta.Datos)
            return
          }

          console.log('Error /getInvoices', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getListInvoiceDetail ({ commit }, data) {
      let params = 'IdCompania=' + data.IdCompania
      params += `&Consecutivo=${data.Consecutivo}`
      params += `&Prefijo=${data.Prefijo}`

      const endpoint = '/getInvoicesDetail?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setListInvoiceDetail', response.data.respuesta.Datos)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    reprocessInvoice ({ commit }, data) {
      const consecutivoDocumento = `${data.Prefijo}-${data.Consecutivo}`

      let params = `consecutivoDocumento=${encodeURIComponent(consecutivoDocumento)}`
      params += `&idCompania=${encodeURIComponent(data.IdCompania)}`

      const endpoint = '/sincronizacionFE?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      return axios
        .create()
        .get(url)
        .then(response => {
          commit('setResponseReprocess', response.data.respuesta)
        })
        .catch(function (error) {
          console.log(error.message)
          commit('setResponseReprocess', { Error: true, Mensaje: error.message })
        })
    },

    getDataFile ({ commit }, data) {
      const ruta = data.url.substr(26)
      const params = `ruta=${ruta}`

      const endpoint = '/getFile?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      commit('setNameFileBase64', data.nameFile)

      axios
        .create()
        .get(url)
        .then(response => {
          commit('setFileBase64', response.data.respuesta)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    sendEmail ({ commit }, data) {
      const consecutivoDocumento = `${data.Prefijo}-${data.Consecutivo}`

      let params = `?consecutivoDocumento=${encodeURIComponent(consecutivoDocumento)}`
      params += `&forzar=1&idCompania=${encodeURIComponent(data.IdCompania)}`

      if (data.emailsAdicionales && data.emailsAdicionales.length > 0) {
        params += `&emailsAdicionales=${encodeURIComponent(data.emailsAdicionales.join(','))}`
      }

      const endpoint = '/notificacionFE'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
          commit('setResponseEmail', response.data.respuesta || {
            Error: true,
            Mensaje: 'El servicio no devolvió una respuesta válida',
          })
        })
        .catch(function (error) {
          commit('setResponseEmail', {
            Error: true,
            Mensaje: `No se pudo enviar el correo: ${error.message}`,
          })
          console.log(error.message)
        })
    },

    setResponseEmail ({ commit }, data) {
      commit('setResponseEmail', data)
    },

    procesarFacturasPCF ({ commit }, payload) {
      const endpoint = '/processDateChange'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      // Obtener el usuario del localStorage
      const user = JSON.parse(atob(localStorage.getItem('uid')))

      // Agregar información del usuario al payload
      const payloadWithUser = {
        ...payload,
        userId: user.userId,
        userName: user.nameUser
      }

      return axios
        .create()
        .post(url, payloadWithUser)
        .then(response => {
          if (!response.data.respuesta.Error) {
            return response.data.respuesta
          } else {
            throw new Error(response.data.respuesta.Mensaje || 'Error al procesar facturas')
          }
        })
        .catch(function (error) {
          console.error('Error en procesarFacturasPCF:', error.message)
          throw error
        })
    },

    generateUnprocessedInvoicesReport ({ commit }, data) {
      const endpoint = '/generateUnprocessedInvoicesReport'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const payload = {
        idCompania: data.IdCompania,
        fechaInicio: data.dateRange[0],
        fechaFin: data.dateRange[1],
        estado: data.Status,
        email: data.email
      }

      axios
        .create()
        .post(url, payload)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setStatusGenerateReportStatus', true)
            commit('setStatusGenerateReportMessage', response.data.respuesta.Mensaje || 'Reporte generado exitosamente. Se enviará al correo indicado.')
          } else {
            commit('setStatusGenerateReportStatus', false)
            commit('setStatusGenerateReportMessage', response.data.respuesta.Mensaje || 'Error al generar el reporte')
          }
        })
        .catch(function (error) {
          console.error('Error al generar reporte:', error.message)
          commit('setStatusGenerateReportStatus', false)
          commit('setStatusGenerateReportMessage', 'Error al generar el reporte: ' + error.message)
        })
    },

    setStatusResponseDownloadReportFile ({ commit }, data) {
      commit('setStatusGenerateReportStatus', data)
      commit('setStatusGenerateReportMessage', '')
    },

    changeInvoiceStatus ({ commit }, payload) {
      const endpoint = '/changeInvoiceStatus'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const user = JSON.parse(atob(localStorage.getItem('uid')))

      const payloadWithUser = {
        ...payload,
        userId: user.userId,
        userName: user.nameUser
      }

      return axios
        .create()
        .post(url, payloadWithUser)
        .then(response => {
          if (!response.data.respuesta.Error) {
            return response.data.respuesta
          }
          throw new Error(response.data.respuesta.Mensaje || 'Error al cambiar estado')
        })
        .catch(function (error) {
          console.error('Error en changeInvoiceStatus:', error.message)
          throw error
        })
    },

  },
}
